<aside class="doc-callout" [attr.data-variant]="variant" role="note">
  <ng-content></ng-content>
</aside>
